// @flow
import type {
  ProductOptionSetting,
  ProductOptionGroup,
  ProductOptionGroupOptionConfig,
} from '../../../entities/product';
import type {
  ProductOptionRequest,
  ProductOptionGroupRequest,
  ProductOptionGroupOptionRequest,
} from '../api';

const mapProductOptionGroupOptionConfig = (
  optionConfig: ProductOptionGroupOptionConfig,
  index: number
): ProductOptionGroupOptionRequest => {
  return {
    storeProductOptionId: optionConfig.storeProductOption?.id || '',
    enabled: optionConfig.storeProductOption?.enabled ?? true,
    useDefault: optionConfig.useDefault,
    price: optionConfig.useDefault
      ? String(optionConfig.storeProductOption?.price) || '0'
      : String(optionConfig.price),
    number: index,
  };
};

const mapProductOptionGroup = (
  group: ProductOptionGroup,
  index: number
): ProductOptionGroupRequest => {
  const options: ProductOptionGroupOptionRequest[] =
    group.options?.map(mapProductOptionGroupOptionConfig, index) || [];

  return {
    storeProductOptionGroupId: group.storeProductOptionGroup.id,
    enabled: group.enabled,
    required: !!group.required,
    fieldType: group.fieldType ?? 'MULTI_OPTION',
    config: {
      minQuantity: group.config?.minQuantity ?? undefined,
      maxQuantity: group.config?.maxQuantity ?? undefined,
      presentationType: group.config?.presentationType || 'LISTING',
    },
    options,
    number: index,
  };
};

export const mapProductOptionSettingToRequest = (
  productOptionSetting: ProductOptionSetting
): ProductOptionRequest => {
  return {
    enabled: productOptionSetting.enabled,
    groups: productOptionSetting.groups.map(mapProductOptionGroup),
  };
};

export const mapProductOptionSettingsToRequests = (
  productOptionSettings: ProductOptionSetting[]
): ProductOptionRequest[] => {
  return productOptionSettings.map(mapProductOptionSettingToRequest);
};
